export const API_ENUMS_TRANSPORTATION_MODE = {
  ocean: "ocean",
  rail: "rail",
  truck: "truck",
  air: "air",
} as const;

export type API_ENUMS_TRANSPORTATION_MODES_TYPE =
  keyof typeof API_ENUMS_TRANSPORTATION_MODE;

export const API_ENUMS = Object.freeze({
  transportationMode: API_ENUMS_TRANSPORTATION_MODE,
  weightUnit: {
    lb: "lb",
    kg: "kg",
  },
  true: "true",
  false: "false",
});
